import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import {
  experimental_extendTheme as extendTheme,
  Experimental_CssVarsProvider as CssVarsProvider,
} from "@mui/material/styles";
import { theme as baseTheme } from "./theme";

const theme = extendTheme({
  ...baseTheme,
  cssVarPrefix: "mams",
});

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <CssVarsProvider theme={theme}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </CssVarsProvider>
  );
};
